import React, { useContext } from 'react';
import { StudyPageContext } from '../../App';
import { useSubjectContext } from '../../pages/subject';
import { Downloader } from '../downloader';
import { exportData } from '../../api/studykit';
import { HasPermission } from '../../context/authorization';

interface MetricExporterProps {
  children: (props: {
    isSubmitting: boolean;
    triggerExport: (startAt: Date, endAt: Date, formatIds: number[]) => Promise<void>;
  }) => React.ReactNode;
}

export const MetricExporter: React.FC<MetricExporterProps> = ({ children }) => {
  const { study } = useContext(StudyPageContext);
  const { subject } = useSubjectContext();

  return (
    <HasPermission value="SubjectsData.Read">
      <Downloader>
        {({ isSubmitting, triggerDownload }) =>
          children({
            isSubmitting,
            triggerExport: (startAt, endAt, formatIds) =>
              triggerDownload(
                `export-${startAt.toLocaleDateString()}-${subject.name}-${formatIds.join(',')}.zip`,
                () => exportData(study.id, subject.id, formatIds, startAt, endAt),
              ),
          })
        }
      </Downloader>
    </HasPermission>
  );
};
